<template>
  <b-container class="py-4 card">
    <h3>Website copy</h3>
    <p>Tips on your website copy</p>

  </b-container>
</template>

<script>

import { db } from '@/main.js'

export default {
  name: 'site_copy',
  props: ['profile', 'site'],
  metaInfo() {
    return {
      title: `site copy`
    };
  },
}
</script>

<style scoped>

</style>
